export const categories = [
    {
        name: 'news',
        image: 'https://i.pinimg.com/750x/eb/47/44/eb4744eaa3b3ccd89749fa3470e2b0de.jpg',
    },
    {
        name: 'events',
        image: 'https://i.pinimg.com/236x/25/14/29/251429345940a47490cc3d47dfe0a8eb.jpg',
    },
    {
        name: 'Facts',
        image: 'https://i.pinimg.com/236x/03/48/b6/0348b65919fcbe1e4f559dc4feb0ee13.jpg',
    },
    {
        name: 'websites',
        image: 'https://i.pinimg.com/750x/66/b1/29/66b1296d36598122e6a4c5452b5a7149.jpg',
    },
    {
        name: 'tech',
        image: 'https://i.pinimg.com/564x/ec/d0/b8/ecd0b8a3e679f7111b7b484aa0adce5c.jpg',
    },
    {
        name: 'photo',
        image: 'https://i.pinimg.com/236x/72/8c/b4/728cb43f48ca762a75da645c121e5c57.jpg',
    },
    {
        name: 'food',
        image: 'https://i.pinimg.com/236x/7d/ef/15/7def15ac734837346dac01fad598fc87.jpg',
    },
    {
        name: 'nature',
        image: 'https://i.pinimg.com/236x/b9/82/d4/b982d49a1edd984c4faef745fd1f8479.jpg',
    },
    {
        name: 'art',
        image: 'https://i.pinimg.com/736x/f4/e5/ba/f4e5ba22311039662dd253be33bf5f0e.jpg',
    }, {
        name: 'travel',
        image: 'https://i.pinimg.com/236x/fa/95/98/fa95986f2c408098531ca7cc78aee3a4.jpg',
    },
    {
        name: 'others',
        image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
    },
];

//getting the user data
export const userQuery = (userId) => {
    const query = `*[_type == 'user' && _id == '${userId}']`;

    return query
}

//query for getting specific category data
export const searchQuery = (categoryId) => {
    const query = `*[_type == 'pin' && title match '${categoryId}*' || category match '${categoryId}*' || about match '${categoryId}*']{
        image{
            asset->{
                url
            }
        },
        _id,
        destination,
        postedBy ->{
            _id,
            userName,
            image
        },
        save[]{
            _key,
            postedBy ->{
                _id,
                username,
                image
            },
        },
    }`

    return query
}

//getting all the posts and feeds 
export const feedQuery = `*[_type == 'pin'] | order(_createdAt desc){
    image{
        asset->{
            url
        }
    },
    _id,
    title,
    about,
    destination,
    postedBy ->{
        _id,
        userName,
        image
    },
    save[]{
        _key,
        postedBy ->{
            _id,
            username,
            image
        },
    },
}`

//query helps to collect the Pin-Details
export const pinDetailQuery = (pinId) => {
    const query = `*[_type == "pin" && _id == '${pinId}']{
      image{
        asset->{
          url
        }
      },
      _id,
      title, 
      about,
      category,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
     save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
      comments[]{
        comment,
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      }
    }`;
    return query;
};

//fetching the related pin with same categories
export const pinDetailMorePinQuery = (pin) => {
    const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
};

//User created query 
export const userCreatedPinsQuery = (userId) => {
    const query = `*[_type == "pin" && userId =='${userId}'] | order(_createdAt desc){
        image{
            asset->{
                url
            }
        },
        _id,
        destination,
        postedBy->{
            _id,
            userName,
            image
        },
        save[]{
            postedBy->{
                _id,
                userName,
                image
            },
        },
    }`;
    return query;
}

//User Saved query 
export const userSavedPinsQuery = (userId) => {
    const query = `*[_type == "pin" && '${userId}' in save[].userId] | order(_createdAt desc){
image{
    asset->{
        url
    }
},
_id,
destination,
postedBy ->{
    _id,
    userName,
    image
},
save[]{
    _key,
    postedBy->{
        _id,
        userName,
        image
      },
},
    }`;
    return query;
}

